import PropTypes from 'prop-types';
import React from 'react';
import { FormattedTime } from 'react-intl';

export const TrlTimeFormatted = ({ value, ...rest }) => {
  if (!value) {
    return null;
  }
  return <FormattedTime value={value} {...rest} />;
};
TrlTimeFormatted.propTypes = {
  value: PropTypes.any,
};
